/**
 * Guest Components
 */
Vue.component('login-form', require('./guest/login/form.vue').default);
Vue.component('sign-up-form', require('./guest/sign-up/form.vue').default);
Vue.component('language-select', require('./guest/language-select.vue').default);

/**
 * Budgets Components
 */
Vue.component('budgets-landing-page', require('./guest/budgets/landing-page/index.vue').default);
Vue.component('budgets-marketing-page', require('./guest/budgets/marketing-page/index.vue').default);
Vue.component('budgets-login-page', require('./guest/budgets/login/index.vue').default);
Vue.component('budgets-sign-up-page', require('./guest/budgets/sign-up/index.vue').default);
Vue.component('budgets-reset-password-form', require('./guest/budgets/reset-password/form.vue').default);

/**
 * User Components
 */
Vue.component('sidebar-navigation', require('./shared/sidebar-navigation.vue').default);
Vue.component('sidebar-footer', require('./shared/sidebar-footer.vue').default);
Vue.component('avatar', require('./user/partials/avatar.vue').default);
Vue.component('organization-logo', require('./user/partials/organization-logo.vue').default);
Vue.component('awaiting-acceptance-page', require('./user/awaiting-acceptance.vue').default);
Vue.component('logout-link', require('./user/logout.vue').default);
Vue.component('verify-page', require('./user/verify.vue').default);
Vue.component('welcome-page', require('./user/welcome.vue').default);
Vue.component('application-list', require('./user/dashboard/application-list.vue').default);
Vue.component('user-list', require('./user/users/user-list.vue').default);
Vue.component('settings-page', require('./user/settings/index.vue').default);
Vue.component('organization-details-page', require('./user/organization-details/index.vue').default);
Vue.component('add-admin-modal', require('./user/organization-details/partials/add-admin-modal.vue').default);
Vue.component('organization-users-page', require('./user/organization-users/index.vue').default);
Vue.component('budgets-verify-page', require('./user/budgets/verify.vue').default);
Vue.component('budgets-welcome-page', require('./user/budgets/welcome.vue').default);
Vue.component('select-application-page', require('./user/select-application.vue').default);
Vue.component('popup-videos-modals', require('./user/popup-videos-modals.vue').default);

/**
 * Admin components
 */
Vue.component('organization-payments-page', require('./admin/organization-payments/index.vue').default);
Vue.component('remove-card-modal', require('./admin/organization-payments/partials/remove-card-modal.vue').default);
Vue.component('update-subscription-plan-modal', require('./admin/organization-payments/partials/update-subscription-plan-modal.vue').default);
Vue.component('accept-join-request-modal', require('./admin/organization-users/partials/accept-join-request-modal.vue').default);
Vue.component('delete-user-modal', require('./admin/organization-users/partials/delete-user-modal.vue').default);
Vue.component('reject-join-request-modal', require('./admin/organization-users/partials/reject-join-request-modal.vue').default);
Vue.component('restore-user-modal', require('./admin/organization-users/partials/restore-user-modal.vue').default);
Vue.component('invite-user-modal', require('./admin/organization-users/partials/invite-user-modal.vue').default);
Vue.component('manage-application-roles-modal', require('./admin/organization-users/partials/manage-application-roles-modal.vue').default);
Vue.component('install-application-modal', require('./admin/dashboard/partials/install-application-modal.vue').default);
Vue.component('delete-application-modal', require('./admin/dashboard/partials/delete-application-modal.vue').default);
Vue.component('courses-page', require('./user/courses/page.vue').default);

/**
 * Kiosk components
 */
Vue.component('kiosk-users-page', require('./kiosk/users/index.vue').default);
Vue.component('kiosk-leave-impersonation-link', require('./kiosk/users/partials/leave-impersonation-link.vue').default);
Vue.component('kiosk-organizations-page', require('./kiosk/organizations/index.vue').default);
Vue.component('kiosk-delete-organization-modal', require('./kiosk/organizations/partials/delete-organization-modal.vue').default);
Vue.component('kiosk-invoices-page', require('./kiosk/invoices/index.vue').default);
Vue.component('kiosk-create-invoice-page', require('./kiosk/invoices/create.vue').default);
Vue.component('kiosk-communication-page', require('./kiosk/communication/index.vue').default);
Vue.component('kiosk-mark-invoice-as-paid-modal', require('./kiosk/invoices/partials/mark-invoice-as-paid-modal.vue').default);
Vue.component('kiosk-updates-page', require('./kiosk/updates/index.vue').default);
Vue.component('kiosk-delete-update-modal', require('./kiosk/updates/partials/delete-update-modal.vue').default);
Vue.component('kiosk-create-update-page', require('./kiosk/updates/create.vue').default);
Vue.component('kiosk-edit-update-page', require('./kiosk/updates/edit.vue').default);
